import { HttpClient } from '@angular/common/http';
import { Injectable, Signal, inject } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { SecurityRoleTiny, TenantUser, UserSetting, isClientPortal } from '@jms/model';
import { Select } from '@jms/shared/ngrx-actions';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;
import { Observable, catchError, map, of, tap } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class CurrentUserService {

    @Select('application.user')
    public user$: Observable<TenantUser>;

    @Select('application.role')
    private role$: Observable<SecurityRoleTiny>;

    public $user: Signal<TenantUser>;
    public $role: Signal<SecurityRoleTiny>;

    private _user: TenantUser;
    public get user(): TenantUser {
        return this._user;
    }

    private _role: SecurityRoleTiny;
    public get role(): SecurityRoleTiny {
        return this._role;
    }

    //private settingsApi = '/api/settings/user';
    private http = inject(HttpClient);

    private get settingsApiUrl() {
        const isPortal = isClientPortal(ConfigService.environment.domainType as any);
        return isPortal
            ? 'https://__tenant__/api/settings/user'
            : '/api/settings/user';
    }

    constructor() {

        this.$user = toSignal(this.user$);
        this.$role = toSignal(this.role$);

        this.user$
            .pipe(
                takeUntilDestroyed(),
                tap(x => {
                    this._user = x
                })
            )
            .subscribe();

        this.role$
            .pipe(
                takeUntilDestroyed(),
                tap(x => {
                    this._role = x
                })
            )
            .subscribe();
    }


    public get<T>(key: string, defaultValue?: T): Observable<T> {

        return this.http
            .get<UserSetting>(`${this.settingsApiUrl}/${key}`)
            .pipe(
                map((x: UserSetting) => (x?.value ?? null) as T),
                catchError(() => of(defaultValue)),
            );
    }

    public set<T>(key: string, value: T): Observable<T> {
        const body = { key, value };
        return this.http
            .post<UserSetting>(`${this.settingsApiUrl}`, body)
            .pipe(
                catchError(() => of(null)),
                map((x: UserSetting) => (x?.value ?? null) as T)
            );
    }
}
